import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=389b7d31&scoped=true&"
import script from "./ProductDetail.vue?vue&type=script&lang=ts&"
export * from "./ProductDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDetail.vue?vue&type=style&index=0&id=389b7d31&prod&scoped=true&lang=css&"
import style1 from "./ProductDetail.vue?vue&type=style&index=1&id=389b7d31&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389b7d31",
  null
  
)

export default component.exports